module.exports = __webpack_public_path__ + "static/media/face.312a007d.jpg";